<template>
  <div class="app-container">
    <el-form
      :model="queryParams"
      ref="queryForm"
      size="small"
      :inline="true"
      v-show="showSearch"
      label-width="120px"
      class="forms"
    >
      <el-form-item label="商品名称" prop="goodsName">
        <el-input
          v-model="queryParams.goodsName"
          placeholder="请输入商品名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="是否匿名评价" prop="isAnonymous">
        <el-radio-group
          v-model="queryParams.isAnonymous"
          size="small"
          class="isRuturn"
        >
          <el-radio style="margin-right: 10px" border label="1">是</el-radio>
          <el-radio style="margin-right: 10px" border label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="search">
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8 mt10">
      <right-toolbar
        :showSearch.sync="showSearch"
        @queryTable="getList"
      ></right-toolbar>
    </el-row>

    <el-table
      v-loading="loading"
      :data="commentList"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        label="订单ID"
        align="center"
        prop="orderId"
        width="280"
        show-overflow-tooltip
      />
      <el-table-column
        label="用户名称"
        align="center"
        prop="nickName"
        show-overflow-tooltip
      />
      <el-table-column
        label="商品名称"
        align="center"
        prop="goodsName"
        show-overflow-tooltip
      />
      <el-table-column label="商品图片" width="120" align="center">
        <template slot-scope="{ row }">
          <div style="cursor: pointer">
            <img
              @click="showImgs(row.goodsImg)"
              style="width: 30px; border-radius: 4px"
              v-if="row.goodsImg"
              src="https://dximg.dexian.ren/lczhsq/Imgs.png"
              alt=""
            />

            <img
              @click="showImgs(row.goodsImg)"
              style="width: 30px; border-radius: 4px"
              v-else
              src="https://dximg.dexian.ren/lczhsq/Imgs1.png"
              alt=""
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="评价内容"
        align="center"
        prop="content"
        show-overflow-tooltip
      />

      <el-table-column
        label="评价时间"
        align="center"
        prop="createTime"
        width="150"
        show-overflow-tooltip
      />
      <el-table-column
        label="回复"
        align="center"
        prop="replyContent"
        show-overflow-tooltip
      />
      <el-table-column
        label="是否匿名评价"
        align="center"
        prop="isAnonymous"
        show-overflow-tooltip
        width="100"
      >
        <template slot-scope="{ row }">
          <el-tag v-if="row.isAnonymous == 0">否</el-tag>
          <el-tag type="success" v-if="row.isAnonymous == 1">是</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
        width="180"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            @click="handleUpdate(scope.row)"
            v-if="!scope.row.replyContent"
            >回复</el-button
          >
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="ShowImg"
      :url-list="srcList"
      hide-on-click-modal
      teleported
      :on-close="closePre"
    />

    <!-- 回复弹窗 -->
    <el-dialog
      title="回复"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="huiFu" ref="huiFu" :rules="huiFuRules">
        <el-form-item label="回复" prop="replyContent">
          <el-input
            v-model="huiFu.replyContent"
            placeholder="请输入回复内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeHf">取 消</el-button>
        <el-button type="primary" @click="submitHf">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
    
    <script>
import {
  listComment,
  delComment,
  addComment,
  updateComment,
} from "@/api/periphery";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: {
    ElImageViewer,
  },
  name: "Comment",
  data() {
    return {
      huiFu: {},
      dialogFormVisible: false,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 周边订单评价表格数据
      commentList: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        goodsName: null,
        userId: null,
        orderId: null,
        goodsId: null,
        goodsScore: null,
        serviceScore: null,
        content: null,
        replyContent: null,
        isAnonymous: null,
        status: null,
        platformId: this.$route.query.platformId,
      },
      huiFuRules: {
        replyContent: [
          { required: true, message: "回复内容不能为空", trigger: "blur" },
        ],
      },
      id: "",
      ShowImg: false,
      srcList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    showImgs(img) {
      if (img) {
        document.body.style.overflow = "hidden";
        this.ShowImg = true;
        this.srcList = img.split(",");
      } else {
        this.$message({
          showClose: true,
          message: "暂时无商品图片",
          type: "warning",
        });
      }
    },
    closePre() {
      console.log(11111);
      this.ShowImg = false;
      document.body.style.overflow = "auto";
    },
    /** 查询周边订单评价列表 */
    getList() {
      this.loading = true;
      listComment(this.queryParams).then((response) => {
        this.commentList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    closeHf() {
      this.dialogFormVisible = false;
      this.huiFu.replyContent = null;
    },

    resetForm(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].resetFields();
      }
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length !== 1;
      this.multiple = !selection.length;
    },

    /** 回复按钮操作 */
    handleUpdate(row) {
      this.dialogFormVisible = true;
      this.id = row.id;
    },
    submitHf() {
      this.huiFu.id = this.id;
      this.$refs["huiFu"].validate((valid) => {
        if (valid) {
          updateComment(this.huiFu).then((response) => {
            this.$modal.msgSuccess("回复成功");
            this.dialogFormVisible = false;
            this.getList();
          });
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal
        .confirm("是否确认删除该订单评价？")
        .then(function () {
          return delComment(ids);
        })
        .then(() => {
          this.getList();
          this.$modal.msgSuccess("删除成功");
        })
        .catch(() => {});
    },
  },
};
</script>
    